import { render, staticRenderFns } from "./unpaid_payment_details.vue?vue&type=template&id=08498dca&"
import script from "./unpaid_payment_details.vue?vue&type=script&lang=js&"
export * from "./unpaid_payment_details.vue?vue&type=script&lang=js&"
import style0 from "./unpaid_payment_details.vue?vue&type=style&index=0&id=08498dca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports